import React from "react";
import { useTranslation } from "react-i18next";
import { FormError } from "@vp/swan";
import { ERROR_TYPE } from "../../../../../commons/constants";

interface ErrorMessageProps {
  type: ERROR_TYPE;
  lowStockMessage?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  type,
  lowStockMessage,
}) => {
  const { t } = useTranslation("translation");
  let errorMessage;
  switch (type) {
    case ERROR_TYPE.SIZE_UNAVAILABLE: // This indicates the size has 0 stock (message hidden so that stock message can be shown without overlap)
      errorMessage = t("groups-and-teams.size-unavailable");
      break;
    case ERROR_TYPE.INSUFFICIENT_STOCK:
      if (lowStockMessage) errorMessage = lowStockMessage;
      break;
    case ERROR_TYPE.SIZE_UNSPECIFIED:
      errorMessage = t("groups-and-teams.size-unspecified");
      break;
    case ERROR_TYPE.QUANTITY_REQUIRED:
      errorMessage = t("groups-and-teams.quantity-required");
      break;
    case ERROR_TYPE.SIZE_INVALID: // This indicates the size is not in the dropdown (only used for spreadsheet upload)
      errorMessage = t("groups-and-teams.size-unavailable");
      break;
    case ERROR_TYPE.INVALID:
    default:
      errorMessage = t("groups-and-teams.field-invalid");
  }
  return <FormError mt={2}>{errorMessage}</FormError>;
};
